import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { useOutletContext } from "react-router-dom";
import { updateProcurement } from "../../services/api/procurementService";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { Button } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';

export default function Tracking() {
  const { procurement, handleUpdateProcurement } = useOutletContext();
  const [actualStartAt, setActualStartAt] = useState();
  const [actualEndAt, setActualEndAt] = useState();
  const [isUpdating, setIsUpdating] = useState(false);

  function validateFields() {
    let validationErrors = [];

    return validationErrors.length === 0;
  }

  async function handleUpdate() {
    try {
      setIsUpdating(true);
      if (validateFields()) {
        await updateProcurement(procurement.uuid, {
          actualStartAt: actualStartAt,
          actualEndAt: actualEndAt,
        });
        await handleUpdateProcurement();
        toast.success("Les informations ont été mises à jour avec succès !");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsUpdating(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 max-w-lg">
      <DatePicker
        label="Début du marché"
        defaultValue={procurement.actualStartAt && new Date(procurement.actualStartAt)}
        onChange={newValue => setActualStartAt(newValue && format(newValue, "yyyy-MM-dd"))}
        slotProps={{
          field: {
            clearable: true, onClear: () => setActualStartAt(null),
          },
          textField: {
            helperText: "Date de début effective du marché.",
          },
        }}

      />
      <DatePicker
        label="Fin du marché"
        defaultValue={procurement.actualEndAt && new Date(procurement.actualEndAt)}
        onChange={newValue => setActualEndAt(newValue && format(newValue, "yyyy-MM-dd"))}
        slotProps={{
          field: {
            clearable: true, onClear: () => setActualEndAt(null),
          },
          textField: {
            helperText: "Date de fin effective du marché.",
          },
        }}
      />
      <div>
        <Button
          variant="contained"
          color="primary"
          disabled={!procurement.canWrite || isUpdating}
          onClick={handleUpdate}
          disableElevation
          loading={isUpdating}
          loadingPosition="end"
          startIcon={<SaveIcon />}
        >
          Enregistrer
        </Button>
      </div>
    </div>
  );
}
